
import { Component, Vue } from 'vue-property-decorator';
import { viagemStore } from '../../../utils/store-accessor';
import { IDeparture } from '@/interfaces/departure';
import { format } from 'date-fns';

@Component
export default class Show extends Vue {
  public headers = [
    {
      text: 'Nome',
      sortable: true,
      value: 'full_name',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Departamento',
      sortable: true,
      value: 'departure',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Cargo',
      sortable: true,
      value: 'role',
      align: 'left',
      filterable: true,
    },
  ];

  public headersEmViagem = [
    {
      text: 'Nome',
      sortable: true,
      value: 'full_name',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Departamento',
      sortable: true,
      value: 'departure',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Cargo',
      sortable: true,
      value: 'role',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Data final da viagem',
      sortable: true,
      value: 'data_fim',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Destino atual',
      sortable: true,
      value: 'destino',
      align: 'left',
      filterable: true,
    },
  ];

  public search = '';

  public loading = false;

  public dialog = false;

  public departureId = '';

  public dataInicial = '';

  public dataFinal = '';

  public disponiveis = [];

  public ocupados = [];

  public dataViagemInicial = format(new Date(), 'yyyy-MM-dd');

  public dataViagemFinal = format(new Date(), 'yyyy-MM-dd');

  public showCalendarDataViagemFinal = false;

  public showCalendarDataViagemInicial = false;

  public selectedDepartureBuscar: IDeparture = {
    id: 0,
    name: 'Todos',
    description: '',
  };

  public async buscar() {
    const users = await viagemStore.getViagensUsersAndTravelStatus({
      departureid: this.selectedDepartureBuscar.id,
      dataInicial: this.dataViagemInicial,
      dataFinal: this.dataViagemFinal,
    });
    this.ocupados = [];
    this.disponiveis = [];
    for (let i = 0; i < users.length; i++) {
      if (users[i].ocupado === false) {
        //@ts-ignore
        this.disponiveis.push(users[i]);
      } else {
        //@ts-ignore
        this.ocupados.push(users[i]);
      }
    }
  }

  public async show() {
    this.dialog = true;
  }
}
